import * as Device from 'expo-device';
import * as Localization from 'expo-localization';
import React, { useEffect, useState } from 'react';
import { browserName, isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import { Dimensions, StyleSheet } from 'react-native';

import Config from '../../config.json';
import { useLessonContext } from '../../hooks';
import { useStudentInfo } from '../../hooks/lesson-player.context';
import { useActivityContext } from '../../hooks/use-activity.context';
import { fetchPost } from '../../utils/fetch-utils';
import { getUserAgent } from '../../utils/user-agent';
import FeedbackDialog from '../feedback/feedback-dialog';
import ThemedText2 from '../themed-text-2';

interface BugReporterProps {
  lessonId: number;
  visible: boolean;
  onClose: (bug?: string) => void;
}

export default function BugReporter({
  lessonId,
  visible,
  onClose,
}: BugReporterProps) {
  const { currentActivity } = useActivityContext();
  const { environment, centrosModeEnabled } = useLessonContext();
  const [postUrl, setPostUrl] = useState('');
  const { t } = useTranslation();
  const studentInfo = useStudentInfo();

  useEffect(() => {
    setPostUrl(`${Config[environment].courseServiceHost}/lesson-errors`);
  }, [environment]);

  const nlsKeys = {
    title: 'mobile.feedback.reportBug.title',
    instructions: 'mobile.feedback.reportBug.paragraph',
    enterText: 'mobile.feedback.reportBug.enterBug',
  };

  async function submit(message: string): Promise<Response> {
    const { width, height } = Dimensions.get('window');
    const body = JSON.stringify({
      message,
      courseId: lessonId,
      errorDate: new Date(),
      mobile: !!Device.brand,
      resolved: false,
      contactId: studentInfo?.contactId,
      device: Device.modelName || null,
      os: `${Device.osName}-${Device.osVersion}`,
      browserLanguage: Localization.locale || navigator.language,
      screenSize: Math.round(height) + ' x ' + Math.round(width),
      elementId: currentActivity.elementId,
      browser:
        browserName !== 'none' ? browserName : isMobile ? 'mobile' : 'none',
      userAgent: getUserAgent(centrosModeEnabled),
    });
    return fetchPost(`${postUrl}`, body);
  }

  return (
    <FeedbackDialog
      visible={visible}
      onClose={onClose}
      onSubmit={submit}
      nlsKeys={nlsKeys}
      successNode={
        <ThemedText2 fontWeightStyle="bold" style={styles.text}>
          {t('mobile.feedback.reportBug.thankYou')}
        </ThemedText2>
      }
    />
  );
}

const styles = StyleSheet.create({
  text: {
    paddingVertical: 30,
    paddingHorizontal: 20,
    textAlign: 'center',
    fontSize: 20,
  },
});
